/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IPaymentSet } from 'types';
import { Payment } from './types';

const initialState: IPaymentSet | null = null;

export const paymentReducer: Reducer<IPaymentSet | null> = (state = initialState, action) => {
  switch (action.type) {
    case Payment.GET_PAYMENT_REQUEST: {
      return initialState;
    }
    case Payment.GET_PAYMENT_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
